import { useEffect, useState } from "react";
import { unwrapResult } from "@reduxjs/toolkit";
import ReactGA from 'react-ga4';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

import './checkout.scss';
import CustomButton from "../../uiKit/Button/CustomButton";

import { donateAllPaymentIntent } from "../../redux/state/paymentSlice";
import { setAllThankOpen, setStripeOpen, setStripeOpenDonateAll } from "../../redux/state/donationSlice";

const CheckoutDonateAll = () => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();

    const savedCard = useSelector(state => state.payment.savedCard, shallowEqual);
    const isLoadingDonateAllIntent = useSelector(state => state.payment.isLoading.donateAllPaymentIntent, shallowEqual);
    const error = useSelector(state => state.payment.error, shallowEqual);
    const body = useSelector(state => state.donation.body, shallowEqual);

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!!error?.errors?.Amount) {
            toast.info(error.errors.Amount[0] ?? 'something went wrong');
        }
    }, [error])

    const payWithSavedCard = () => {
        ReactGA.event(`donate_${pathname.split('/')[1].replace('-', '_')}_with_saved_card_checkout`);
        setIsLoading(true);
        dispatch(donateAllPaymentIntent({
            body,
            paymentMethodId: savedCard.id,
        }))
            .then(unwrapResult)
            .then((response) => {
                if (response.status === 'Success') {
                    dispatch(setStripeOpen(false));
                    dispatch(setStripeOpenDonateAll(false));
                    dispatch(setAllThankOpen(true));
                }
                else {
                    toast.info(response.title ?? response.errorMessage ?? 'Something went wrong.')
                }
            })
            .catch(({ title }) => {
                toast.info(`Payment failed: ${title}`)
            })
            .finally(() => setIsLoading(false));
    }

    return (
        <CustomButton
            title='Donate'
            onClick={payWithSavedCard}
            style={{ marginTop: '16px' }}
            disabled={isLoading || isLoadingDonateAllIntent}
            loading={isLoading || isLoadingDonateAllIntent}
        />
    )
}

export default CheckoutDonateAll;